import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class RichDescription extends DataModel {
  static readonly TYPE_ID: string = 'a5877e2717384653b5ba67201f876992';
  private static readonly kPlainLineBreak: string = '\n';
  private static readonly kRichLineBreak: string = '[{"insert":"\\n"}]';

  constructor(
        public readonly text: string,
        public readonly richText: string,
  ) {
    super();
  }

  get $typeId() {
    return RichDescription.TYPE_ID;
  }

  // Based on QuillController and Document constructor implementation.
  // Document delta must always end with a line-break.
  // Therefore a description containing only one line-break is considered empty.
  get hasText(): boolean {
    return this.text != '' && this.text != RichDescription.kPlainLineBreak;
  }

  get hasRichText(): boolean {
    return this.richText != '' && this.richText != RichDescription.kRichLineBreak;
  }

  get isNotEmpty(): boolean {
    return this.hasText || this.hasRichText;
  }

  get isEmpty(): boolean {
    return !this.isNotEmpty;
  }

  static empty(): RichDescription {
    return new RichDescription(
        '',
        '',
    );
  }

  static plain(text: string): RichDescription {
    return new RichDescription(
        text,
        text,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): RichDescription {
    return new RichDescription(
        MapUtils.get<string>(map, 'text'),
        MapUtils.get<string>(map, 'richText'),
    );
  }

  toMap(): SerializedData {
    return {
      'text': this.text,
      'richText': this.richText,
    };
  }

  clone(): this {
    return new RichDescription(
        this.text,
        this.richText,
    ) as this;
  }

  isSame(other: RichDescription): boolean {
    if(other === this) {
      return true;
    }

    return other.text == this.text &&
        other.richText == this.richText;
  }
}

export class RichDescriptionBuilder extends DataModelBuilder<RichDescription> {
  build(context: SerializationContext, map: SerializedData): RichDescription {
    return RichDescription.fromMap(context, map);
  }
}
